import { render, staticRenderFns } from "./AdminUsersTable.module.vue?vue&type=template&id=2368d522&scoped=true&"
import script from "./AdminUsersTable.module.vue?vue&type=script&lang=js&"
export * from "./AdminUsersTable.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsersTable.module.vue?vue&type=style&index=0&id=2368d522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368d522",
  null
  
)

export default component.exports